
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/month_view/templates/loading_view"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='progress-bar-wrapper'>\n  <div class='progress-wrap progress'>\n    <div\n      class='progress-bar progress'\n      id=\"calendar-view-loader\"\n      role=\"progressbar\"\n      aria-valuemin=\"0\"\n      aria-valuemax=\"100\"\n      aria-valuetext=\"Loading...\"></div>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  